import React, { useEffect, useState } from 'react'
import { Grid, Box, Typography, useTheme } from '@mui/material'
import RenderFields from './RenderFields'
import RenderProduct from './RenderProduct'

const RenderContent = ({
  strategy,
  setStrategy,
  organization,
  sectionKey,
  sectionLabel,
  section,
  isEditMode,
  onServiceFieldChange,
  onSaveProduct,
  errors,
  dealId,
  productEditStates,
  handleStartProductEdit,
  handleStopProductEdit,
  handleSaveProductEdit,
}) => {
  const theme = useTheme()

  const [paidSearchSection, setPaidSearchSection] = useState([])
  const [paidSocialSection, setPaidSocialSection] = useState([])
  const [displaySection, setDisplaySection] = useState([])
  // Ensure the section is at least an empty array to avoid undefined errors
  const services = section || []
  const searchSubcategories = ['Search']
  const socialSubcategories = ['Social', 'Audio']
  useEffect(() => {
    if (services && Array.isArray(services)) {
      const paidSearch = services.filter(service => searchSubcategories.includes(service.subcategory))
      const paidSocial = services.filter(service => socialSubcategories.includes(service.subcategory))
      const display = services.filter(service => service.subcategory === 'Display')
      setPaidSearchSection(paidSearch ?? [])
      setPaidSocialSection(paidSocial ?? [])
      setDisplaySection(display ?? [])
    }
  }, [services])

  if (!services.length) {
    return null
  }

  return (
    <>
      {paidSearchSection?.length > 0 ? (
        <>
          <Grid item xs={12} key={`header-${sectionKey}`}>
            <Typography
              sx={{ color: theme.palette.text.primary, ml: 1 }}
              variant="h6"
              gutterBottom
            >
              {'Search'}
            </Typography>
          </Grid>
          <Box
            sx={{
              bgcolor: theme.palette.background.main,
              border: '1px solid',
              borderColor: theme.palette.text.secondary,
            }}
          >
            {paidSearchSection.map(service => {
              return (
                <Box key={service.instanceId}>
                  <Grid item xs={12} pb={0.5}>
                    <RenderProduct
                      strategy={strategy}
                      organization={organization}
                      service={service}
                      isEditing={!!productEditStates[service.instanceId]}
                      onEditClick={handleStartProductEdit}
                      onCancelClick={handleStopProductEdit}
                      onSaveClick={handleSaveProductEdit}
                      hasErrors={errors?.updatedProducts?.[service.instanceId] ?? {}}
                    />
                  </Grid>
                  <RenderFields
                    sectionKey={sectionKey}
                    key={service.instanceId}
                    service={service}
                    isEditMode={!!productEditStates[service.instanceId]}
                    onChange={onServiceFieldChange}
                    errors={errors?.updatedProducts?.[service.instanceId] ?? {}}
                    isDisabled={isEditMode}
                  />
                </Box>
              )
            })}
          </Box>
        </>
      ) : null}
      {paidSocialSection?.length > 0 ? (
        <>
          <Grid item xs={12}>
            <Typography
              sx={{ color: theme.palette.text.primary, ml: 1 }}
              variant="h6"
              gutterBottom
            >
              {'Social'}
            </Typography>
          </Grid>
          <Box
            sx={{
              bgcolor: theme.palette.background.main,
              border: '1px solid',
              borderColor: theme.palette.text.secondary,
            }}
          >
            {paidSocialSection.map(service => {
              return (
                <Box key={service.instanceId}>
                  <Grid item xs={12} pb={0.5}>
                    <RenderProduct
                      strategy={strategy}
                      organization={organization}
                      service={service}
                      isEditing={!!productEditStates[service.instanceId]}
                      onEditClick={handleStartProductEdit}
                      onCancelClick={handleStopProductEdit}
                      onSaveClick={handleSaveProductEdit}
                      hasErrors={errors?.updatedProducts?.[service.instanceId] ?? {}}
                    />
                  </Grid>
                  <RenderFields
                    sectionKey={sectionKey}
                    key={service.instanceId}
                    service={service}
                    isEditMode={!!productEditStates[service.instanceId]}
                    onChange={onServiceFieldChange}
                    errors={errors?.updatedProducts?.[service.instanceId] ?? {}}
                    isDisabled={isEditMode}
                  />
                </Box>
              )
            })}
          </Box>
        </>
      ) : null}
      {displaySection?.length > 0 ? (
        <>
          <Grid item xs={12}>
            <Typography
              sx={{ color: theme.palette.text.primary, ml: 1 }}
              variant="h6"
              gutterBottom
            >
              {'Display'}
            </Typography>
          </Grid>
          <Box
            sx={{
              bgcolor: theme.palette.background.main,
              border: '1px solid',
              borderColor: theme.palette.text.secondary,
            }}
          >
            {displaySection.map(service => (
              <Box key={service.instanceId}>
                <Grid item xs={12} pb={0.5}>
                  <RenderProduct
                    strategy={strategy}
                    organization={organization}
                    service={service}
                    isEditing={!!productEditStates[service.instanceId]}
                    onEditClick={handleStartProductEdit}
                    onCancelClick={handleStopProductEdit}
                    onSaveClick={handleSaveProductEdit}
                    hasErrors={errors?.updatedProducts?.[service.instanceId] ?? {}}
                  />
                </Grid>
                <RenderFields
                  sectionKey={sectionKey}
                  key={service.instanceId}
                  service={service}
                  isEditMode={!!productEditStates[service.instanceId]}
                  onChange={onServiceFieldChange}
                  errors={errors?.updatedProducts?.[service.instanceId] ?? {}}
                  isDisabled={isEditMode}
                />
              </Box>
            ))}
          </Box>
        </>
      ) : null}
    </>
  )
}

export default RenderContent
